<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col">
      <div class="form-label">{{this.label}}</div>
    </div>
  </div>
  <div class="row mt-{{LABEL_SPACING}}">
    <div class="col">
      <select 
        id="{{this.propertyId}}"
        name="{{this.propertyName}}"  
        formControlName="{{this.propertyName}}" 
        class="form-control"
        [ngClass]="[regular ? '' : 'input-box']"
        (change)="this.userAction($event)">
          <option *ngFor="let p of states" [value]="p.code">{{p.display}}</option>
      </select>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>